<template>
  <v-container fill-height fluid grid-list-xl>
    <v-form ref="form" v-model="validForm" class="pregnancy_upsert" v-if="!loadError">
      <!-- //issue vari -->
      <safety-pregnancy-treatment-modal v-model="openTreatments" :savefun="save"  :pregnancy="item" />
      <!-- //issue vari -->
      <v-layout justify-center wrap white>
        <v-flex xs12 sm2 md2>
          <v-text-field
            label="Case Identification Number"
            v-model="cin"
            disabled
          ></v-text-field>
        </v-flex>

        <v-flex xs12 sm2 md2>
          <v-select
            clearable
            md4
            v-model="selectedProtocol"
            :items="protocols"
            label="Protocol"
            :rules="validators.pregnancy.protocol"
            item-value="id"
            item-text="name"
            return-object
            :disabled="!isNew"
            :readonly="!$can('upsert', 'pregnancy')"
          ></v-select>
        </v-flex>

        <v-flex xs12 sm2 md2>
          <v-text-field
            label="Patient"
            :disabled="!isNew"
            v-model="item.patient_id"
            :rules="validators.pregnancy.patient"
            @input="searchCenter()"
            :readonly="!$can('upsert', 'pregnancy')"
          ></v-text-field>
        </v-flex>

        <v-flex xs12 sm2 md2>
          <v-autocomplete
            md4
            clearable
            :search-input.sync="siteSearchString"
            v-model="selectedSite"
            :items="sites"
            color="primary"
            hide-no-data
            item-text="name"
            item-value="id"
            label="Site"
            return-object
            prepend-icon="mdi-database-search"
            :loading="loadingSites"
            :disabled="!isNew || !item.protocol_id"
            :rules="validators.pregnancy.site"
            :readonly="!$can('upsert', 'pregnancy')"
          >
            <template slot="item" slot-scope="{ item }">
              <v-list-tile-content>
                <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                <v-list-tile-sub-title>{{item.city}} ({{
                  item.country_code
                }})</v-list-tile-sub-title>
              </v-list-tile-content>
            </template>
          </v-autocomplete>
        </v-flex>


        <v-flex xs12 sm2 md2>
          <v-select
            clearable
            required
            label="Case Type"
            v-model="item.case_type"
            :rules="validators.pregnancy.case_type"
            :items="['Initial', 'Follow up', 'Final']"
            :disabled="!isNew"
            :readonly="!$can('upsert', 'pregnancy')"
          ></v-select>
        </v-flex>

        <v-flex xs12 sm2 md2>
          <v-menu
            v-model="menu_datePicker_receipt_date"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
            :disabled="!isNew"
            :readonly="!$can('upsert', 'pregnancy')"
          >
            <template slot="activator">
              <v-text-field
                clearable
                v-model="item.receipt_date"
                label="Receipt Date"
                :disabled="!isNew"
                readonly
                :rules="validators.pregnancy.receipt_date"
              ></v-text-field>
            </template>
            <v-date-picker
              :disabled="!isNew"
              dark
              v-model="item.receipt_date"
              no-title
              @input="menu_datePicker_receipt_date = false"
              :readonly="!$can('upsert', 'pregnancy')"
            ></v-date-picker>
          </v-menu>
        </v-flex>



        <v-flex xs12 sm2 md2>
          <v-menu
            v-model="menu_datePicker_start_date_last_menses"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
            :readonly="!$can('upsert', 'pregnancy')"
          >
            <template slot="activator">
              <v-text-field
                clearable
                v-model="item.start_date_last_menses"
                label="Start date last menses"
                _rules="validators.pregnancy.start_date_last_menses"
                readonly
              ></v-text-field>
            </template>
            <v-date-picker
              dark
              v-model="item.start_date_last_menses"
              no-title
              @input="menu_datePicker_start_date_last_menses = false"
              :readonly="!$can('upsert', 'pregnancy')"
            ></v-date-picker>
          </v-menu>
        </v-flex>


        <v-flex xs12 sm2 md2>
          <v-text-field
            label="Pregnant Year of birth"
            v-model="item.year_of_birth"
            type="number"
            :readonly="!$can('upsert', 'pregnancy')"
          ></v-text-field>
        </v-flex>


        <v-flex xs12 sm2 md2>
          <v-menu
            v-model="menu_datePicker_anticipated_date_of_childbirth"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
            :readonly="!$can('upsert', 'pregnancy')"
          >
            <template slot="activator">
              <v-text-field
                clearable
                v-model="item.anticipated_date_of_childbirth"
                label="Anticipated date of childbirth"
                readonly
              ></v-text-field>
            </template>
            <v-date-picker
              dark
              v-model="item.anticipated_date_of_childbirth"
              no-title
              @input="menu_datePicker_anticipated_date_of_childbirth = false"
              :readonly="!$can('upsert', 'pregnancy')"
            ></v-date-picker>
          </v-menu>
        </v-flex>

        <v-flex xs12 sm2 md2>
          <v-menu
            v-model="menu_datePicker_date_pregnancy_confirmed"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
            :readonly="!$can('upsert', 'pregnancy')"
          >
            <template slot="activator">
              <v-text-field
                clearable
                v-model="item.date_pregnancy_confirmed"
                label="Date pregnancy confirmed"
                readonly
              ></v-text-field>
            </template>
            <v-date-picker
              dark
              v-model="item.date_pregnancy_confirmed"
              no-title
              @input="menu_datePicker_date_pregnancy_confirmed = false"
              :readonly="!$can('upsert', 'pregnancy')"
            ></v-date-picker>
          </v-menu>
        </v-flex>


        <v-flex xs12 sm4 md4>
          <v-select
            label="Outcome"
            v-model="item.outcome"
            clearable
            :items="[
              'Not known at this date',
              'Uneventful (normal/healthy baby)',
              'Induced abortion',
              'Spontaneous abortion',
              'Still birth',
              'Neonatal death',
              'Birth defects',
              'Other'
            ]"
            :readonly="!$can('upsert', 'pregnancy')"
          ></v-select>
        </v-flex>
      

        <v-flex xs12 sm2 md2>
          <v-select
            clearable
            md4
            v-model="item.pregnant"
            :items="['patient', 'partner']"
            label="Pregnant"
            :readonly="!$can('upsert', 'pregnancy')"
          ></v-select>
        </v-flex>


        <v-flex xs12 sm6 md6>
          <v-textarea
            label="Clinical Comments"
            v-model="item.clinical_comments"
            rows="1"
            clearable
            :readonly="!$can('upsert', 'pregnancy')"
          ></v-textarea>
        </v-flex>

        <!--v-flex xs12 sm2 md2>
          <v-checkbox label="CRF" v-model="item.crf" :readonly="!$can('upsert', 'pregnancy')"></v-checkbox>
        </v-flex-->

     
        <v-flex xs12 sm2 md2>
          <!--v-checkbox
            label="Quality Check"
            v-model="item.quality_check"
            :readonly="!$can('upsert', 'pregnancy')"
          ></v-checkbox-->
          <v-tooltip top close-delay='300' min-width='50px'>
            <template slot="activator" slot-scope="{ on }">
                <v-btn
                    v-on="item.quality_check ? on : {}"
                    class="mx-1 font-weight-light"
                    small
                    :disabled="isNew || !$can('upsert', 'pregnancy') || item.account.role == 'Guest' || item.account.role == 'Provider' || item.status == 'Canceled'"
                    @click="qualitycheckModal = true"
                    :color="qualitycheckColor">
                    <v-icon small>mdi-check</v-icon> &nbsp;&nbsp; Quality Check
                </v-btn>
                </template>
              <span>{{item.quality_check_date}}</span>
          </v-tooltip>
        </v-flex>


        <v-flex xs12 sm2 md2>
          <v-select
            clearable
            md4
            v-model="item.status"
            :items="['Open', 'Close', 'Warning', 'Query', 'Canceled']"
            label="Status"
            :readonly="!$can('upsert', 'pregnancy')"
          ></v-select>
        </v-flex>


        <!-- //issue vari -->
        <v-flex xs12 sm2 md2> 
            <v-text-field v-show="false" v-model="item.treatments" label="treatments" readonly></v-text-field>
        </v-flex>
        <!-- //issue vari -->


        <v-flex xs12 text-xs-right>


          <v-btn
            color="pink"
            dark
            class="mx-1 font-weight-light"
            small
            dense
            @click="$router.go(-1)">
            <v-icon small>mdi-arrow-left</v-icon>
          </v-btn>

          <v-tooltip top close-delay='2000' min-width='400px' v-if="item.pdf">
            <template slot="activator" slot-scope="{ on }">
                <v-btn
                    v-on="item.pdf ? on : {}" 
                    small
                    class="mx-1 font-weight-light"
                    :disabled="isNew || !$can('upsert', 'pregnancy') || item.status == 'Canceled'"
                    @click="pickFile"
                    :color="item.pdf ? 'green' : 'pink' ">
                    <v-icon small>mdi-upload</v-icon> &nbsp;&nbsp; PDF
                    &nbsp;&nbsp;
                    <v-btn v-if="canRemovePdf" color="pink" class="remove-pdf" @click.stop="removePDF()">
                      X
                    </v-btn>
                </v-btn>
              </template>
              <span><a @click="downloadPdf">{{item.pdf}}</a></span>
          </v-tooltip>
          <!-- Per evitare bug grafici dovuti al tooltip ho duplicato il bottone -->
          <v-btn v-else
              v-on="item.pdf ? on : {}" 
              small
              class="mx-1 font-weight-light"
              :disabled="isNew || !$can('upsert', 'spm') || item.status == 'Canceled'"
              @click="pickFile"
              :color="'pink'">
              <v-icon small>mdi-upload</v-icon> &nbsp;&nbsp; PDF
          </v-btn>


          <v-tooltip top min-width='200px'>
            <template slot="activator" slot-scope="{ on }">
                <v-btn
                  v-on="item.company_notification_date ? on : {}" 
                  class="mx-1 font-weight-light"
                  :disabled="isNew || !item.pdf || !$can('upsert', 'pregnancy') || item.status == 'Canceled'"
                  @click="notifyCompany()"
                  small
                  :color="item.company_notification_date ? 'green' : 'pink' "
                  >
                  <v-icon small>mdi-email-send</v-icon>  &nbsp;&nbsp; Company</v-btn>
              </template>
              <span>Notified on {{item.company_notification_date}}</span>
          </v-tooltip>


          <v-tooltip top min-width='200px'>
            <template slot="activator" slot-scope="{ on }">
                <v-btn
                  v-on="item.medical_notification_date ? on : {}" 
                  class="mx-1 font-weight-light"
                  :color="item.medical_notification_date ? 'green' : 'pink' "
                  :disabled="isNew || !item.pdf || !$can('upsert', 'pregnancy') || item.status == 'Canceled'"
                  small
                  @click="notifyMedicalMonitor()"
                  >
                  <v-icon small>mdi-email-send</v-icon>  &nbsp;&nbsp; Medical Monitor</v-btn>
              </template>
              <span>Notified on {{item.medical_notification_date}}</span>
          </v-tooltip>


          <v-btn
            :disabled="isNew || !$can('upsert', 'pregnancy') || item.status == 'Canceled'"
            class="mx-1 font-weight-light"
            color="success"
            small
            @click="openTreatments = true"
            > <v-icon small>mdi-pill</v-icon>  &nbsp;&nbsp;Treatments</v-btn
          >
          <v-btn
            class="mx-1 font-weight-light"
            color="purple"
            small
            :loadingSave="loadingSave"
            :disabled="((!checkSave() && !validForm)  || item.status == 'Canceled') || loadingSave"
            @click="save()"
            v-if="$can('upsert', 'pregnancy')"
            >Save</v-btn
          >
        </v-flex>


        <!-- <v-flex xs12 v-if="$can('read', 'audittrail')">
          <safety-audittrail-timeline v-if="!isNew" entity="pregnancy" :entity_id="$route.params.id" />
        </v-flex> -->


        <input
          id="file"
          ref="file"
          type="file"
          style="display: none"
          accept=".pdf, application/pdf"
          @change="handleFileUpload()"
        />

      </v-layout>
    </v-form>

    <v-layout justify-center wrap white v-if="loadError">
      <v-flex xs12 sm12 md12>
        <v-alert type="warning" :value="true">
          ERROR Loading Pregnancy record!
        </v-alert>
      </v-flex>
    </v-layout>

    <v-dialog v-model="notifyModal" persistent max-width="1100px">
      <material-card color="primary" :title="'Notify ' + notifyType + ' (' + item.cin + ')'">
        <v-form ref="form">
          <v-container grid-list-md>
            <v-layout wrap>

              <v-flex xs12 sm12 md12>
                <v-autocomplete
                  clearable
                  md4
                  chips
                  box
                  multiple
                  v-model="confirmed_emails_to_notify"
                  :items="emails_to_notify"
                  label="Email Address"
                >
                
                <template slot="selection" slot-scope="data">
                  <v-chip :color="userTypeColor[data.item.type]" class="chip--select-multi">
                    {{ data.item.email }}
                  </v-chip>
                </template>

                <template slot="item" slot-scope="data">
                  <template v-if="!isObject(data.item)">
                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                  </template>
                  <template v-else>
                    <v-list-tile-action>
                      <v-checkbox v-model="confirmed_emails_to_notify.filter( s => s.email == data.item.email).length"> </v-checkbox>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title v-html=" '(' + data.item.name + ') ' + data.item.email">  </v-list-tile-title>
                      <v-list-tile-sub-title :style="'color:' + userTypeColor[data.item.type]"  v-html="data.item.typeStr || data.item.type"></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </template>
                </template>
                
                </v-autocomplete>
              </v-flex>


              <v-flex xs12 sm12 md12>
                <v-text-field
                  label="Email Subject"
                  v-model="emailSubject"
                  clearable
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md12>
                <v-textarea
                  label="Email Body"
                  v-model="emailBody"
                  rows="18"
                  clearable
                ></v-textarea>
              </v-flex>

            </v-layout>
          </v-container>
        </v-form>

        <v-flex xs12 text-xs-right>
          <v-btn class="mx-1 font-weight-light" color="success" @click="notifyModal = false; emails_to_notify = confirmed_emails_to_notify = []">Close</v-btn>

          <v-btn
            class="mx-1 font-weight-light"
            color="pink"
            :disabled="!confirmed_emails_to_notify.length || !$can('upsert', 'pregnancy')"
            @click="confirmNotify()"
            >Notify now</v-btn
          >
        </v-flex>
      </material-card>
    </v-dialog>

    <safety-pdf-preview-modal v-model="pdfPreview" :item="item" itemType="pregnancy"/>
    <safety-qualitycheck-modal v-model="qualitycheckModal" :itemEvent.sync="item" eventType="pregnancy"/>

  </v-container>
</template>

<script>
import { getList as getPREList, upsert, getDetail, uploadPdf,removePdf, downloadPdf, nextCin, notifyPregnancy } from "@/api/pregnancy";
import validators from "@/utils/validators";
import { getList as getSites } from "@/api/site";
import { getList as getProtocolSites } from "@/api/protocol_site";
import { getCompanyUserByPre } from "@/api/company_user";
import { getList as getExternalUser } from "@/api/external_user";
import { emailBody, emailSubject } from "@/utils/pre_mail";

export default {
  inheritAttrs: false,
  data() {
    return {
      item: {protocol:{}},
      validForm: true,
      validators,
      menu_datePicker_anticipated_date_of_childbirth: false,
      menu_datePicker_date_pregnancy_confirmed: false,
      menu_datePicker_receipt_date: false,
      menu_datePicker_start_date_last_menses: false,
      siteSearchString: "",
      loadingSites: false,
      sites: [],
      extuserSearchString: "",
      loadingExtUser: false,
      loadingSave:false,
      external_users: [],
      openTreatments: false,
      selectedSite: null,
      selectedProtocol: null,
      pdf: null,
      notifyModal: false,
      emails_to_notify: [],
      confirmed_emails_to_notify: [],
      notifyType: null,
      emailBodySend: null,
      emailSubjectSend: null,
      userTypeColor: {
        'Personnel' : '#adcc46',
        'Medical monitor' : '#ff9494',
        'Company user' : '#f3ac33',
      },
      pdfPreview: false,
      qualitycheckModal: false,
      loadError: false
    };
  },
  created() {
    this.$store.dispatch("app/sponsorsDisabled", true);
  },
  mounted() {
    if (this.$route.params.id) {
      this.getData(this.$route.params.id);
    }
  },
  watch: {
    siteSearchString(val, oldVal) {
      if (!val) {
        this.sites = [];
        return;
      }
      this.loadingSites = true;
      getProtocolSites({ "site.name": "%" + val + "%", "protocol_id" : this.item.protocol_id }, { rowsPerPage: null }).then(data => {
        const sites = data.data.map(el => {
          return el['site'];
        });
        this.sites = sites;
        this.loadingSites = false;
      });
    },
    selectedSite(v) {
      if (v) {
        this.item.site_id = v.id;
      } 
    },
    selectedProtocol(v) {
      if (v) {
        this.item.protocol_id = v.id;
      } else {
        this.sites = [];
        this.selectedSite = null;
        this.item.site_id = null;
        this.item.protocol_id = null;
      }
    },
    extuserSearchString(val, oldVal) {
      if (!val) {
        this.sites = [];
        return;
      }
      this.loadingExtUser = true;
      getExternalUser(
        { name: val + "%", protocol_id: this.item.protocol_id },
        { rowsPerPage: null }
      ).then(data => {
        this.external_users = data.data;
        this.loadingExtUser = false;
      });
    },
  },
  asyncComputed: {
    cin: {
      async get() {
        if (
          this.isNew &&
          this.selectedSite &&
          this.selectedProtocol &&
          this.item.patient_id &&
          this.item.receipt_date &&
          this.item.case_type
        ) {
          this.item.cin = this.selectedSite.country_code + '-' + this.selectedProtocol.name + '-' + this.item.patient_id + '-P';
          return this.item.cin;
        }
        return this.isNew ? null : this.item.cin;
      },
      set(v) {
        this.item.cin = v;
      }
    },
  },
  computed: {
    canRemovePdf(){
      return ['Administrator','Employee'].includes(this.$store.getters.userObj.role ) && this.item.pdf ? true : false
    },
    protocols() {
      return this.$store.getters.protocols;
    },
    isNew() {
      return this.item.id ? false : true;
    },
    title() {
      return this.isNew ? "New Pregnancy Event" : "Edit Pregnancy Event";
    },
    emailBody: {
      get() {
        const def = emailBody(this.item, this.notifyType);
        this.emailBodySend = def;
        return def;
      },
      set(v) {
        this.emailBodySend = v;
      }
    },
    emailSubject: {
      get() {
        const def = emailSubject(this.item, this.notifyType);
        this.emailSubjectSend = def;
        return def;
      },
      set(v) {
         this.emailSubjectSend = v;
      }
    },
    qualitycheckColor() {
      if (this.item.quality_check) {
        return 'green';
      }
      return 'pink'
    }
  },
  methods: {
    removePDF(){
      this.$store.dispatch("app/startLoading");
      removePdf(this.item.id)
      .then((data)=>{
        if(data){
          this.$store.dispatch("app/stopLoading");
          this.item.pdf=''
        }
      })
      .catch(() => {
        this.$store.dispatch("app/openSnackbar", {
          message:
            "An Error occurred during pdf delete " +
            e.response.data.message,
          color: "error"
        });
        this.$store.dispatch("app/stopLoading");
      }).finally(() => {
        this.$store.dispatch("app/stopLoading");
      });
    },
    getData(id) {
      return getDetail(id, this.projectId).then(data => {
        // const newItem = JSON.parse(JSON.stringify(data).replace('""', /null/i));

        this.item = data;
        this.sites = [this.item.site];
        this.selectedSite = this.item.site;
        this.selectedProtocol = this.item.protocol;

        this.$store.commit("app/pregnancyItem", data);
        this.$store.dispatch("app/loadSponsors");
        this.loadError = false
      }).catch( e => {
        this.loadError = true
      });
    },
    calculateAge() {
      let age = new Date().getFullYear() - this.item.year_of_birth;
      this.item.age = null;
      if (age > 10 && age < 100) {
        this.item.age = age;
      }
    },
    checkSave() {
      return !this.isNew;
    },
    customArmTxt(arm) {
      return arm.rnd + ' - ' + arm.key;
    },
    customArmValue(arm) {
      return arm.key;
    },
    save() {
      if (!this.$refs.form.validate()) {
        this.$store.dispatch("app/openSnackbar", {
          message: "Please fix validation errors!",
          color: "error"
        });
        return;
      }
      this.loadingSave=true
      upsert(this.item)
        .then(data => {
          this.$store.dispatch("app/openSnackbar", {
            message: this.isNew ? "Pregnancy created correctly" : "Pregnancy updated correctly",
            color: "success"
          });
          if(!data.data){
            const newItem = JSON.parse(
              JSON.stringify(data.data).replace('""', /null/i)
            );
          }else{
            const newItem=data.data
            this.getData(data.data.id);
          }
        })
        .catch(e => {
          this.$store.dispatch("app/openSnackbar", {
            message:
              "An Error occurred during the Pregnancy update. " +
              e.response.data.message,
            color: "error"
          });
        }).finally(() => {
      this.loadingSave = false
    });
      
    },
    notifyCompany() {

       // get company users
      getCompanyUserByPre(
        { pre: this.item }
      ).then(cue => {
        const cueel = cue.map( el => { 
          el['type'] = 'Company user'; 
          el['typeStr'] = 'Company user (' + el.company.name + ')'; 
          return el; 
        });
       // get external user (Personnel)
        getExternalUser(
          { protocol_id: this.item.protocol_id, type: 'Personnel' },
          { rowsPerPage: null }
        ).then(etn => {
          // const etn = data.data.map( el => {return el.email; });
          this.emails_to_notify = this.confirmed_emails_to_notify = [...cueel, ...etn.data];//[...new Set(cue), ...new Set(etn)];
        });

      });

      this.notifyType = 'Company';
      this.notifyModal = true;
    },
    notifyMedicalMonitor() {

      getExternalUser(
        { protocol_id: this.item.protocol_id, type: 'Medical Monitor' },
        { rowsPerPage: null }
      ).then(etn => {
        // const etn = data.data.map( el => {return el.email; });
        this.emails_to_notify = this.confirmed_emails_to_notify = etn.data;//[...new Set(etn)];
      });

      this.notifyType = 'Medical Monitor';
      this.notifyModal = true;
    },
    closeNotify() {
      this.notifyModal = false;
    },
    confirmNotify() {

      const notifyParams = {
        id : this.item.id,
        type : this.notifyType,
        emailSubject : this.emailSubjectSend,
        emailBody : this.emailBodySend,
        to: this.confirmed_emails_to_notify
      };

      notifyPregnancy(notifyParams).then( data => {

        this.$store.dispatch("app/openSnackbar", {
          message: "Pregnancy Event correctly notified to " + this.notifyType,
          color: "success"
        });

        if (data.company_notification_date) {
          this.item.company_notification_date = data.company_notification_date;
        }
        if (data.medical_notification_date) {
          this.item.medical_notification_date = data.medical_notification_date;
        }

      }).catch( e => {
         this.$store.dispatch("app/openSnackbar", {
            message:
              "An Error occurred during the Pregnancy Event " + this.notifyType + " notify. " +
              e.response.data.message,
            color: "error"
          });
      }).finally( () => {
         this.$store.dispatch("app/stopLoading");
      });

      this.notifyModal = false;
      this.$store.dispatch("app/startLoading");

    },
    pickFile() {
      this.$refs.file.click();
    },
    handleFileUpload(event) {

      const file = this.$refs.file.files[0];
      if (!file) {
        return;
      }
      this.$store.dispatch("app/startLoading");
      let formData = new FormData();
      formData.append('file', file);
      formData.append('id', this.item.id);

      uploadPdf(formData).then( data => {
        this.item.pdf = data.pdf;
        //issue vari
        this.save();
        //issue vari
      }).catch( (e) => {
        this.$store.dispatch("app/openSnackbar", {
            message:
              "An Error occurred during pdf upload " +
              e.response.data.message,
            color: "error"
          });
      }).finally( () => {
         this.$store.dispatch("app/stopLoading");
      });
      this.$refs.file.value = '';
    },
    downloadPdf() {

      this.pdfPreview = true

      // this.$store.dispatch("app/startLoading");
      // downloadPdf(this.item.id, this.item.pdf).then( d => {
        
      // }).catch( e => {
      //     this.$store.dispatch("app/openSnackbar", {
      //       message:
      //         "An Error occurred during pdf upload " +
      //         e.response.data.message,
      //       color: "error"
      //     });
      // }).finally( () => {
      //    this.$store.dispatch("app/stopLoading");
      // });
    },
    searchCenter() {
      if (this.item.protocol_id && this.item.patient_id) {
        getPREList({protocol_id: this.item.protocol_id, patient_id: this.item.patient_id}, {rowsPerPage: null}).then( data => {
          if(data.tot > 0) {
            this.sites = [data.data[0].site];
            this.selectedSite = data.data[0].site;
          } else {
            this.selectedSite = {}
          }
        });
      }
    },
    isObject(v) {
      return typeof v == 'object'
    }
  }
};
</script>

<style>
.remove-pdf{
  margin: 0;
  padding: 0; 
  min-width: 30%;
  min-height: 0;
}

#core-view {
  padding-bottom: 100px;
}

.theme--light.v-label {
  font-size: 14px;
  color: #aaa;
  font-weight: 400;
}

.pregnancy_upsert .v-select__selection--comma {
  max-width: 200px !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}


</style>
